// Snowflake Stellar-mapped legacy color palettes (values only).

export const grey = {
  25: '#ffffff',
  50: '#fbfbfb',
  100: '#f7f7f7',
  200: '#eceef1',
  300: '#dee3ea',
  400: '#9fabc1',
  500: '#5d6a85',
  600: '#5d6a85',
  700: '#191e24',
  800: '#0f161e',
  900: '#0f161e'
};

export const error = {
  25: '#ffced0',
  50: '#ffced0',
  100: '#fccfcc',
  200: '#ffced0',
  300: '#ffced0',
  400: '#ef405e',
  500: '#d3132f',
  600: '#d3132f',
  700: '#d3132f',
  800: '#d3132f',
  900: '#d3132f'
};

export const warning = {
  25: '#fad67b',
  50: '#fad67b',
  100: '#f5d791',
  200: '#fad67b',
  300: '#fad67b',
  400: '#f8c52a',
  500: '#ecb700',
  600: '#ecb700',
  700: '#ecb700',
  800: '#ecb700',
  900: '#ecb700'
};

export const success = {
  25: '#a0e9cd',
  50: '#a0e9cd',
  100: '#b0e5d1',
  200: '#b0e5d1',
  300: '#a0e9cd',
  400: '#51d9ae',
  500: '#51caa5',
  600: '#51caa5',
  700: '#51caa5',
  800: '#51caa5',
  900: '#51caa5'
};

export const foamGreen = {
  100: '#a0e9cd',
  200: '#b0e5d1',
  300: '#b0e5d1',
  400: '#a0e9cd',
  500: '#51d9ae',
  600: '#51caa5',
  700: '#51caa5',
  800: '#51caa5',
  900: '#51caa5',
  1000: '#51caa5'
};

export const blue = {
  25: '#c5dcff',
  50: '#c5dcff',
  100: '#c6dbfd',
  200: '#c6dbfd',
  300: '#c5dcff',
  400: '#3580f2',
  500: '#1a6ce7',
  600: '#1a6ce7',
  700: '#1a6ce7',
  800: '#1a6ce7',
  900: '#1a6ce7'
};

export const darkPrimary = {
  '200': '#5d6a85',
  '100': '#191e24'
};

export const natomaBlack = '#23272c';
export const natomaGreen = '#276ee1';
export const natomaDark = '#191e24';
export const natomaLight = grey['200'];
